export const NO_VALUE_PLACEHOLDER = '-';
export const MULTIPLE_VALUES = 'Multiple';
